<div class="container">
    <div class="col-md-10 pl-0">
        <div class="mb-3">
            <h5 class="rps-heading-five">Key facts</h5>
        </div>
        <table class="table key-fact-table">
            <tbody>
                <tr *ngIf="overviewModel?.isETF && overviewModel?.isInternalFund">
                    <th scope="row">
                        <p class="rps-paragraph-one rps-mark-narrow">
                            <span>

                             <a role="button" class="secYieldLink dialog-button" (click)="setDialogInfo('Intraday optimized value ticker'); keyFactsComponentModal.openModalDialog($event);" tabindex="0" href="javascript:void(0)">
                                 IOV ticker symbol
                             </a>
                         </span>
                        </p>
                    </th>
                    <td style="text-align: left;">
                        <p class="rps-paragraph-one rps-mark-narrow" data-rpa-tag-id="overview-kf-iov-ticker" *ngIf="overviewModel?.iovticker; else  mdash">{{overviewModel?.iovticker }}</p>
                        <ng-template #mdash>
                            <h4 class="mb-0 pl-2 rps-heading-four" data-rpa-tag-id="overview-kf-iov-ticker">&mdash;</h4>
                        </ng-template>
                    </td>
                </tr>
                <tr *ngIf="!overviewModel?.is529 && overviewModel?.isInternalFund">
                    <th scope="row">
                        <p class="rps-paragraph-one rps-mark-narrow">CUSIP</p>
                    </th>
                    <td style="text-align: left;">
                        <p class="rps-paragraph-one rps-mark-narrow" data-rpa-tag-id="overview-kf-cusip" *ngIf="overviewModel?.cusip; else  mdash">{{overviewModel?.cusip}}</p>
                        <ng-template #mdash>
                            <h4 class="mb-0 pl-2 rps-heading-four" data-rpa-tag-id="overview-kf-cusip">&mdash;</h4>
                        </ng-template>
                    </td>
                </tr>
                <tr class="internalView" *ngIf="overviewModel?.isExternalFund && internal">
                    <th scope="row">
                        <p class="rps-paragraph-one rps-mark-narrow">CUSIP</p>
                    </th>
                    <td style="text-align: left;">
                        <p class="rps-paragraph-one rps-mark-narrow" *ngIf="overviewModel?.cusip; else  mdash">{{overviewModel?.cusip}}</p>
                        <ng-template #mdash>
                            <h4 class="mb-0 pl-2 rps-heading-four">&mdash;</h4>
                        </ng-template>
                    </td>
                </tr>
                <tr *ngIf="overviewModel?.isInternalFund">
                    <th scope="row">
                        <p class="rps-paragraph-one rps-mark-narrow">Management style</p>
                    </th>
                    <td style="text-align: left;">
                        <p class="rps-paragraph-one rps-mark-narrow" data-rpa-tag-id="overview-kf-managementType" *ngIf="overviewModel?.managementStyle; else  mdash">{{overviewModel?.managementStyle}}</p>
                        <ng-template #mdash>
                            <h4 class="mb-0 pl-2 rps-heading-four" data-rpa-tag-id="overview-kf-managementType">&mdash;</h4>
                        </ng-template>
                    </td>
                </tr>
                <tr>
                    <th scope="row">
                        <p class="rps-paragraph-one rps-mark-narrow">Asset class</p>
                    </th>
                    <td style="text-align: left;">
                        <p class="rps-paragraph-one rps-mark-narrow" data-rpa-tag-id="assetClass" *ngIf="overviewModel?.assetClass; else  mdash">{{overviewModel?.assetClass}}</p>
                        <ng-template #mdash>
                            <h4 class="mb-0 pl-2 rps-heading-four" data-rpa-tag-id="assetClass">&mdash;</h4>
                        </ng-template>
                    </td>
                </tr>
                <tr>
                    <th scope="row">
                        <p class="rps-paragraph-one rps-mark-narrow">Category</p>
                    </th>
                    <td style="text-align: left;">
                        <p class="rps-paragraph-one rps-mark-narrow" data-rpa-tag-id="category" *ngIf="overviewModel?.category; else  mdash">{{overviewModel?.category}}</p>
                        <ng-template #mdash>
                            <h4 class="mb-0 pl-2 rps-heading-four" data-rpa-tag-id="category">&mdash;</h4>
                        </ng-template>
                    </td>
                </tr>
                <tr *ngIf="overviewModel?.isMoneyMarket">
                    <th scope="row">
                        <p class="rps-paragraph-one rps-mark-narrow">Product type</p>
                    </th>
                    <td style="text-align: left;">
                        <p class="rps-paragraph-one rps-mark-narrow">
                            <span>
                            <a role="button" class="secYieldLink dialog-button" tabindex="0" href="javascript:void(0)" (click)="setDialogInfo('Retail'); keyFactsComponentModal.openModalDialog($event);" *ngIf="overviewModel.secDesignation == 'RETL'">
                                Retail
                            </a>
                            <a role="button" class="secYieldLink dialog-button" tabindex="0" href="javascript:void(0)" (click)="setDialogInfo('Government Money Market Funds'); keyFactsComponentModal.openModalDialog($event);" *ngIf="overviewModel.secDesignation == 'GOVT'">
                               Government
                           </a>
                       </span>
                            <span *ngIf="(overviewModel.secDesignation == 'GOVT' || overviewModel.secDesignation == 'RETL') else  mdash"></span>
                            <ng-template #mdash>
                                <h4 class="mb-0 rps-heading-four">&mdash;</h4>
                            </ng-template>
                        </p>
                    </td>
                </tr>
                <tr>
                    <th scope="row">
                        <p class="rps-paragraph-one rps-mark-narrow">Inception date</p>
                    </th>
                    <td style="text-align: left;">
                        <p class="rps-paragraph-one rps-mark-narrow" data-rpa-tag-id="overview-kf-inceptionDate" *ngIf="overviewModel?.inceptionDate; else  mdash">{{ overviewModel?.inceptionDate | ESTPipe }}</p>
                        <ng-template #mdash>
                            <h4 class="mb-0 pl-2 rps-heading-four" data-rpa-tag-id="overview-kf-inceptionDate">&mdash;</h4>
                        </ng-template>
                    </td>
                </tr>
                <tr *ngIf="overviewModel?.isETF || overviewModel?.isMutualFund">
                    <th scope="row">
                        <p class="rps-paragraph-one rps-mark-narrow">Fund Number</p>
                    </th>
                    <td style="text-align: left;">
                        <p class="rps-paragraph-one rps-mark-narrow" data-rpa-tag-id="fundNum" *ngIf="overviewModel?.fundId; else  mdash">{{ overviewModel?.fundId}}</p>
                        <ng-template #mdash>
                            <h4 class="mb-0 pl-2 rps-heading-four" data-rpa-tag-id="fundNum">&mdash;</h4>
                        </ng-template>
                    </td>
                </tr>
                <tr *ngIf="!(overviewModel?.isETF || overviewModel?.isMutualFund)">
                    <th scope="row">
                        <p class="rps-paragraph-one rps-mark-narrow">Portfolio Number</p>
                    </th>
                    <td style="text-align: left;">
                        <p class="rps-paragraph-one rps-mark-narrow" data-rpa-tag-id="portfolioNum" *ngIf="overviewModel?.fundId; else  mdash">{{ overviewModel?.fundId}}</p>
                        <ng-template #mdash>
                            <h4 class="mb-0 pl-2 rps-heading-four" data-rpa-tag-id="portfolioNum">&mdash;</h4>
                        </ng-template>
                    </td>
                </tr>

            </tbody>
        </table>
    </div>
  <c11n-modal-dialog
    modalId="keyFactsComponentModal"
    [headingText]="dialogTitle"
    #keyFactsComponentModal
  >
    <div c11n-modal-dialog-body>
      <ng-container *ngTemplateOutlet="simpleDialogContent"></ng-container>
    </div>
  </c11n-modal-dialog>
  <ng-template #simpleDialogContent>
    <div *ngIf="dialogTitle === 'Government Money Market Funds'">
      <p [innerHTML]="government" class="rps-paragraph-one align-with-header"></p>
    </div>
    <div *ngIf="dialogTitle === 'Retail'">
      <p [innerHTML]="retail" class="rps-paragraph-one align-with-header"></p>
    </div>
    <div *ngIf="dialogTitle === 'Intraday optimized value ticker'">
      <p [innerHTML]="iovTickerSymbol" class="rps-paragraph-one align-with-header"></p>
    </div>
  </ng-template>
</div>
